var map = {
	"./其他.png": 1776,
	"./其它平台.png": 18127,
	"./冷链.png": 34824,
	"./冷链运输平台.png": 95895,
	"./制造与商贸企业平台.png": 44068,
	"./协会.png": 9796,
	"./危化.png": 25598,
	"./危化运输平台.png": 61894,
	"./商砼.png": 40267,
	"./商砼运输平台.png": 78369,
	"./商贸.png": 33891,
	"./家具.png": 47954,
	"./家具配送平台.png": 73105,
	"./普货运输.png": 33790,
	"./物流.png": 9764,
	"./物流承运商平台.png": 80818,
	"./行业协会平台.png": 47514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99954;